// Blog posts data with SEO optimization
export const blogPosts = [
  {
    id: 1,
    slug: 'rudra-abhishek-ke-fayde-aur-sachai',
    title: {
      hi: 'जानें रुद्र अभिषेक से क्या सच में फल मिलता है?',
      en: 'Know What Real Benefits You Get from Rudra Abhishek?'
    },
    excerpt: {
      hi: 'रुद्र अभिषेक एक अत्यंत पावन और शक्तिशाली पूजा है जो भगवान शिव को समर्पित की जाती है। जानें इसके वास्तविक लाभ।',
      en: 'Rudra Abhishek is an extremely sacred and powerful worship dedicated to Lord Shiva. Learn its real benefits.'
    },
    content: {
      hi: `<h2>रुद्र अभिषेक क्या है?</h2>
      <p>रुद्र अभिषेक भगवान शिव की एक विशेष पूजा पद्धति है जिसमें शिवलिंग पर गंगाजल, दूध, दही, मधु, घी और अन्य पवित्र द्रव्यों से अभिषेक किया जाता है।</p>
      
      <h3>रुद्र अभिषेक के मुख्य लाभ:</h3>
      <ul>
        <li><strong>मानसिक शांति:</strong> तनाव और चिंता से मुक्ति मिलती है</li>
        <li><strong>आर्थिक समृद्धि:</strong> धन-संपत्ति में वृद्धि होती है</li>
        <li><strong>स्वास्थ्य सुधार:</strong> शारीरिक और मानसिक स्वास्थ्य में सुधार</li>
        <li><strong>नकारात्मक ऊर्जा का नाश:</strong> बुरी शक्तियों से सुरक्षा</li>
      </ul>
      
      <h3>सही समय और विधि:</h3>
      <p>रुद्र अभिषेक सोमवार को या शिवरात्रि के दिन करना विशेष फलदायी माना जाता है। प्रातःकाल 6-8 बजे का समय सबसे उत्तम है।</p>`,
      
      en: `<h2>What is Rudra Abhishek?</h2>
      <p>Rudra Abhishek is a special worship method of Lord Shiva where the Shivling is bathed with Ganga water, milk, curd, honey, ghee, and other sacred substances.</p>
      
      <h3>Main Benefits of Rudra Abhishek:</h3>
      <ul>
        <li><strong>Mental Peace:</strong> Relief from stress and anxiety</li>
        <li><strong>Financial Prosperity:</strong> Increase in wealth and property</li>
        <li><strong>Health Improvement:</strong> Better physical and mental health</li>
        <li><strong>Negative Energy Removal:</strong> Protection from evil forces</li>
      </ul>
      
      <h3>Right Time and Method:</h3>
      <p>Performing Rudra Abhishek on Monday or Shivratri is considered especially fruitful. Early morning 6-8 AM is the best time.</p>`
    },
    category: {
      hi: 'पूजा-पाठ',
      en: 'Worship & Rituals'
    },
    tags: [
      { hi: 'रुद्र अभिषेक', en: 'Rudra Abhishek' },
      { hi: 'शिव पूजा', en: 'Shiva Worship' },
      { hi: 'मंत्र', en: 'Mantra' },
      { hi: 'आध्यात्म', en: 'Spirituality' }
    ],
    author: {
      hi: 'आचार्य अभिषेक पांडेय',
      en: 'Acharya Abhishek Pandey'
    },
    publishDate: '2025-09-20',
    readTime: { hi: '5 मिनट', en: '5 minutes' },
    featured: true,
    metaDescription: {
      hi: 'जानें रुद्र अभिषेक के वास्तविक लाभ, सही विधि और समय। आचार्य अभिषेक पांडेय से पाएं प्रामाणिक जानकारी।',
      en: 'Learn real benefits of Rudra Abhishek, proper method and timing. Get authentic information from Acharya Abhishek Pandey.'
    },
    keywords: {
      hi: 'रुद्र अभिषेक, शिव पूजा, मंत्र, आध्यात्म, ज्योतिष',
      en: 'rudra abhishek, shiva worship, mantra, spirituality, astrology'
    }
  },
  {
    id: 2,
    slug: 'tiger-stone-benefits-astrology',
    title: {
      hi: 'बाघ का पत्थर (टाइगर स्टोन) कितना लाभकारी है?',
      en: 'How Beneficial is Tiger Stone (Tiger Eye)?'
    },
    excerpt: {
      hi: 'बाघ का पत्थर या टाइगर आई एक शक्तिशाली रत्न है जो साहस, आत्मविश्वास और सुरक्षा प्रदान करता है।',
      en: 'Tiger Stone or Tiger Eye is a powerful gemstone that provides courage, confidence and protection.'
    },
    content: {
      hi: `<h2>बाघ का पत्थर क्या है?</h2>
      <p>बाघ का पत्थर, जिसे टाइगर आई भी कहते हैं, एक अर्ध-कीमती रत्न है जो अपनी विशिष्ट सुनहरी और भूरी धारियों के लिए प्रसिद्ध है।</p>
      
      <h3>टाइगर स्टोन के फायदे:</h3>
      <ul>
        <li><strong>आत्मविश्वास में वृद्धि:</strong> मानसिक शक्ति बढ़ाता है</li>
        <li><strong>बुरी नज़र से सुरक्षा:</strong> नकारात्मक ऊर्जा से बचाव</li>
        <li><strong>व्यापार में लाभ:</strong> धन और समृद्धि लाता है</li>
        <li><strong>स्वास्थ्य सुधार:</strong> आंखों और पेट की समस्याओं में राहत</li>
      </ul>
      
      <h3>कैसे पहनें:</h3>
      <p>बाघ का पत्थर अंगूठी या लटकन के रूप में पहना जाता है। मंगलवार के दिन सूर्योदय के समय पहनना शुभ माना जाता है।</p>`,
      
      en: `<h2>What is Tiger Stone?</h2>
      <p>Tiger Stone, also called Tiger Eye, is a semi-precious gemstone famous for its distinctive golden and brown stripes.</p>
      
      <h3>Benefits of Tiger Stone:</h3>
      <ul>
        <li><strong>Increased Confidence:</strong> Enhances mental strength</li>
        <li><strong>Protection from Evil Eye:</strong> Guards against negative energy</li>
        <li><strong>Business Profits:</strong> Brings wealth and prosperity</li>
        <li><strong>Health Improvement:</strong> Relief from eye and stomach problems</li>
      </ul>
      
      <h3>How to Wear:</h3>
      <p>Tiger stone is worn as a ring or pendant. Wearing it on Tuesday at sunrise is considered auspicious.</p>`
    },
    category: {
      hi: 'रत्न विज्ञान',
      en: 'Gemstone Science'
    },
    tags: [
      { hi: 'बाघ का पत्थर', en: 'Tiger Stone' },
      { hi: 'रत्न', en: 'Gemstone' },
      { hi: 'सुरक्षा', en: 'Protection' },
      { hi: 'ज्योतिष', en: 'Astrology' }
    ],
    author: {
      hi: 'आचार्य अभिषेक पांडेय',
      en: 'Acharya Abhishek Pandey'
    },
    publishDate: '2025-09-18',
    readTime: { hi: '4 मिनट', en: '4 minutes' },
    featured: false,
    metaDescription: {
      hi: 'बाघ का पत्थर के फायदे, पहनने की विधि और सही समय जानें। टाइगर स्टोन से पाएं सुरक्षा और समृद्धि।',
      en: 'Learn benefits of tiger stone, how to wear and right time. Get protection and prosperity with tiger stone.'
    },
    keywords: {
      hi: 'बाघ का पत्थर, टाइगर स्टोन, रत्न, सुरक्षा, ज्योतिष',
      en: 'tiger stone, tiger eye, gemstone, protection, astrology'
    }
  },
  {
    id: 3,
    slug: 'navratri-puja-vidhi-benefits',
    title: {
      hi: 'नवरात्रि पूजा की संपूर्ण विधि और लाभ',
      en: 'Complete Method and Benefits of Navratri Worship'
    },
    excerpt: {
      hi: 'नवरात्रि के 9 दिनों में मां दुर्गा की विशेष पूजा करने से जीवन में सुख, समृद्धि और शक्ति का संचार होता है।',
      en: 'Special worship of Maa Durga during 9 days of Navratri brings happiness, prosperity and power in life.'
    },
    content: {
      hi: `<h2>नवरात्रि का महत्व</h2>
      <p>नवरात्रि हिंदू धर्म का सबसे महत्वपूर्ण त्योहार है जो मां दुर्गा की शक्ति और कृपा प्राप्त करने के लिए मनाया जाता है।</p>
      
      <h3>नवरात्रि पूजा की विधि:</h3>
      <ol>
        <li><strong>घटस्थापना:</strong> पहले दिन कलश स्थापना करें</li>
        <li><strong>दैनिक पूजा:</strong> प्रतिदिन आरती और मंत्र जाप</li>
        <li><strong>व्रत नियम:</strong> सात्विक भोजन और संयम</li>
        <li><strong>कन्या पूजन:</strong> नवमी को कुंवारी कन्याओं की पूजा</li>
      </ol>
      
      <h3>नवरात्रि के अद्भुत लाभ:</h3>
      <ul>
        <li>शत्रुओं पर विजय</li>
        <li>मानसिक और शारीरिक शक्ति</li>
        <li>धन-संपत्ति में वृद्धि</li>
        <li>संतान सुख</li>
      </ul>`,
      
      en: `<h2>Significance of Navratri</h2>
      <p>Navratri is the most important festival of Hinduism celebrated to receive the power and grace of Maa Durga.</p>
      
      <h3>Navratri Worship Method:</h3>
      <ol>
        <li><strong>Ghatasthapana:</strong> Install Kalash on first day</li>
        <li><strong>Daily Worship:</strong> Daily aarti and mantra chanting</li>
        <li><strong>Fasting Rules:</strong> Sattvic food and restraint</li>
        <li><strong>Kanya Pujan:</strong> Worship of virgin girls on Navami</li>
      </ol>
      
      <h3>Amazing Benefits of Navratri:</h3>
      <ul>
        <li>Victory over enemies</li>
        <li>Mental and physical strength</li>
        <li>Increase in wealth and property</li>
        <li>Happiness of children</li>
      </ul>`
    },
    category: {
      hi: 'त्योहार और व्रत',
      en: 'Festivals & Fasts'
    },
    tags: [
      { hi: 'नवरात्रि', en: 'Navratri' },
      { hi: 'दुर्गा पूजा', en: 'Durga Puja' },
      { hi: 'व्रत', en: 'Fast' },
      { hi: 'त्योहार', en: 'Festival' }
    ],
    author: {
      hi: 'आचार्य अभिषेक पांडेय',
      en: 'Acharya Abhishek Pandey'
    },
    publishDate: '2025-09-15',
    readTime: { hi: '6 मिनट', en: '6 minutes' },
    featured: true,
    metaDescription: {
      hi: 'नवरात्रि पूजा की संपूर्ण विधि, व्रत नियम और चमत्कारी लाभ जानें। मां दुर्गा की कृपा से पाएं सभी मनोकामनाएं।',
      en: 'Learn complete method of Navratri worship, fasting rules and miraculous benefits. Get all desires fulfilled with Maa Durga\'s grace.'
    },
    keywords: {
      hi: 'नवरात्रि पूजा, दुर्गा माता, व्रत विधि, त्योहार',
      en: 'navratri puja, durga mata, fasting method, festival'
    }
  },
  {
    id: 4,
    slug: 'hanuman-chalisa-benefits-daily-reading',
    title: {
      hi: 'हनुमान चालीसा के चमत्कारी फायदे - रोज पढ़ने से मिलते हैं ये लाभ',
      en: 'Miraculous Benefits of Hanuman Chalisa - Benefits of Daily Reading'
    },
    excerpt: {
      hi: 'हनुमान चालीसा का नियमित पाठ जीवन में अद्भुत बदलाव लाता है। जानें इसके वैज्ञानिक और आध्यात्मिक लाभ।',
      en: 'Regular recitation of Hanuman Chalisa brings amazing changes in life. Know its scientific and spiritual benefits.'
    },
    content: {
      hi: `<h2>हनुमान चालीसा की महिमा</h2>
      <p>तुलसीदास जी द्वारा रचित हनुमान चालीसा एक अत्यंत शक्तिशाली स्तोत्र है जो हनुमान जी की कृपा दिलाने में सक्षम है।</p>
      
      <h3>दैनिक पाठ के फायदे:</h3>
      <ul>
        <li><strong>मानसिक शांति:</strong> तनाव और चिंता से मुक्ति</li>
        <li><strong>शारीरिक स्वास्थ्य:</strong> रोग प्रतिरोधक क्षमता बढ़ती है</li>
        <li><strong>बाधा निवारण:</strong> जीवन की सभी बाधाएं दूर होती हैं</li>
        <li><strong>आर्थिक सुधार:</strong> धन और समृद्धि में वृद्धि</li>
      </ul>
      
      <h3>सही समय और नियम:</h3>
      <p>मंगलवार और शनिवार को हनुमान चालीसा का पाठ विशेष फलदायी है। प्रातःकाल स्नान के बाद पूर्व या उत्तर दिशा में बैठकर पढ़ें।</p>`,
      
      en: `<h2>Glory of Hanuman Chalisa</h2>
      <p>Hanuman Chalisa composed by Tulsidas ji is an extremely powerful hymn capable of bringing Hanuman ji's grace.</p>
      
      <h3>Benefits of Daily Recitation:</h3>
      <ul>
        <li><strong>Mental Peace:</strong> Freedom from stress and anxiety</li>
        <li><strong>Physical Health:</strong> Immunity increases</li>
        <li><strong>Obstacle Removal:</strong> All life obstacles are removed</li>
        <li><strong>Financial Improvement:</strong> Increase in wealth and prosperity</li>
      </ul>
      
      <h3>Right Time and Rules:</h3>
      <p>Reciting Hanuman Chalisa on Tuesday and Saturday is especially fruitful. Read sitting in east or north direction after morning bath.</p>`
    },
    category: {
      hi: 'मंत्र और स्तोत्र',
      en: 'Mantras & Hymns'
    },
    tags: [
      { hi: 'हनुमान चालीसा', en: 'Hanuman Chalisa' },
      { hi: 'हनुमान जी', en: 'Hanuman Ji' },
      { hi: 'मंत्र', en: 'Mantra' },
      { hi: 'भक्ति', en: 'Devotion' }
    ],
    author: {
      hi: 'आचार्य अभिषेक पांडेय',
      en: 'Acharya Abhishek Pandey'
    },
    publishDate: '2025-09-12',
    readTime: { hi: '5 मिनट', en: '5 minutes' },
    featured: false,
    metaDescription: {
      hi: 'हनुमान चालीसा के चमत्कारी फायदे और नियमित पाठ के लाभ जानें। हनुमान जी की कृपा से पाएं सभी कष्टों से मुक्ति।',
      en: 'Learn miraculous benefits of Hanuman Chalisa and benefits of regular recitation. Get freedom from all troubles with Hanuman ji\'s grace.'
    },
    keywords: {
      hi: 'हनुमान चालीसा, हनुमान जी, मंत्र जाप, आध्यात्म',
      en: 'hanuman chalisa, hanuman ji, mantra chanting, spirituality'
    }
  },
  {
    id: 5,
    slug: 'grah-dosh-nivaran-upay',
    title: {
      hi: 'ग्रह दोष निवारण के प्रभावी उपाय - ज्योतिष के अनुसार',
      en: 'Effective Remedies for Planetary Defects - According to Astrology'
    },
    excerpt: {
      hi: 'ज्योतिष शास्त्र के अनुसार ग्रह दोषों के कारण जीवन में कई समस्याएं आती हैं। जानें सभी दोषों के सरल उपाय।',
      en: 'According to astrology, many problems in life are caused by planetary defects. Know simple remedies for all defects.'
    },
    content: {
      hi: `<h2>ग्रह दोष क्या हैं?</h2>
      <p>जन्म कुंडली में ग्रहों की खराब स्थिति के कारण होने वाली समस्याओं को ग्रह दोष कहते हैं।</p>
      
      <h3>मुख्य ग्रह दोष और उपाय:</h3>
      <ul>
        <li><strong>मंगल दोष:</strong> मंगलवार को हनुमान चालीसा पाठ, लाल मसूर दान</li>
        <li><strong>शनि दोष:</strong> शनिवार को तेल दान, काले तिल का दान</li>
        <li><strong>राहु-केतु दोष:</strong> सर्प दोष पूजा, गोमेद और लहसुनिया धारण</li>
        <li><strong>शुक्र दोष:</strong> शुक्रवार को लक्ष्मी पूजा, श्वेत वस्त्र दान</li>
      </ul>
      
      <h3>सामान्य उपाय:</h3>
      <p>नियमित पूजा-पाठ, दान-धर्म, और सही रत्न धारण करने से ग्रह दोषों से मुक्ति मिलती है।</p>`,
      
      en: `<h2>What are Planetary Defects?</h2>
      <p>Problems caused by bad position of planets in birth chart are called planetary defects.</p>
      
      <h3>Main Planetary Defects and Remedies:</h3>
      <ul>
        <li><strong>Mangal Dosh:</strong> Hanuman Chalisa recitation on Tuesday, red lentil donation</li>
        <li><strong>Shani Dosh:</strong> Oil donation on Saturday, black sesame donation</li>
        <li><strong>Rahu-Ketu Dosh:</strong> Serpent defect worship, wearing hessonite and cat's eye</li>
        <li><strong>Shukra Dosh:</strong> Lakshmi worship on Friday, white cloth donation</li>
      </ul>
      
      <h3>General Remedies:</h3>
      <p>Regular worship, charity, and wearing right gemstones provide freedom from planetary defects.</p>`
    },
    category: {
      hi: 'ज्योतिष समाधान',
      en: 'Astrological Solutions'
    },
    tags: [
      { hi: 'ग्रह दोष', en: 'Planetary Defects' },
      { hi: 'ज्योतिष', en: 'Astrology' },
      { hi: 'उपाय', en: 'Remedies' },
      { hi: 'कुंडली', en: 'Horoscope' }
    ],
    author: {
      hi: 'आचार्य अभिषेक पांडेय',
      en: 'Acharya Abhishek Pandey'
    },
    publishDate: '2025-09-10',
    readTime: { hi: '7 मिनट', en: '7 minutes' },
    featured: false,
    metaDescription: {
      hi: 'ग्रह दोष निवारण के प्रभावी उपाय और ज्योतिष समाधान जानें। मंगल, शनि, राहु-केतु दोष से पाएं मुक्ति।',
      en: 'Learn effective remedies for planetary defects and astrological solutions. Get freedom from Mangal, Shani, Rahu-Ketu defects.'
    },
    keywords: {
      hi: 'ग्रह दोष निवारण, मंगल दोष, शनि दोष, ज्योतिष उपाय',
      en: 'planetary defect remedies, mangal dosh, shani dosh, astrological remedies'
    }
  }
];

// Blog categories for filtering
export const blogCategories = [
  { 
    id: 'all',
    name: { hi: 'सभी', en: 'All' },
    slug: 'all'
  },
  { 
    id: 'puja-path',
    name: { hi: 'पूजा-पाठ', en: 'Worship & Rituals' },
    slug: 'worship-rituals'
  },
  { 
    id: 'gemstone',
    name: { hi: 'रत्न विज्ञान', en: 'Gemstone Science' },
    slug: 'gemstone-science'
  },
  { 
    id: 'festivals',
    name: { hi: 'त्योहार और व्रत', en: 'Festivals & Fasts' },
    slug: 'festivals-fasts'
  },
  { 
    id: 'mantras',
    name: { hi: 'मंत्र और स्तोत्र', en: 'Mantras & Hymns' },
    slug: 'mantras-hymns'
  },
  { 
    id: 'astrology',
    name: { hi: 'ज्योतिष समाधान', en: 'Astrological Solutions' },
    slug: 'astrological-solutions'
  }
];

// Helper functions for blog operations
export const getBlogPostBySlug = (slug) => {
  return blogPosts.find(post => post.slug === slug);
};

export const getFeaturedPosts = () => {
  return blogPosts.filter(post => post.featured);
};

export const getPostsByCategory = (categorySlug) => {
  if (categorySlug === 'all') return blogPosts;
  
  const category = blogCategories.find(cat => cat.slug === categorySlug);
  if (!category) return [];
  
  return blogPosts.filter(post => 
    post.category.en === category.name.en || 
    post.category.hi === category.name.hi
  );
};

export const getRecentPosts = (limit = 3) => {
  return [...blogPosts]
    .sort((a, b) => new Date(b.publishDate) - new Date(a.publishDate))
    .slice(0, limit);
};

export const searchBlogPosts = (query, language = 'hi') => {
  const searchTerm = query.toLowerCase();
  
  return blogPosts.filter(post => 
    post.title[language].toLowerCase().includes(searchTerm) ||
    post.excerpt[language].toLowerCase().includes(searchTerm) ||
    post.content[language].toLowerCase().includes(searchTerm) ||
    post.tags.some(tag => tag[language].toLowerCase().includes(searchTerm))
  );
};

// SEO helper function to generate structured data for blog posts
export const generateBlogPostStructuredData = (post, language = 'hi') => {
  return {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    "headline": post.title[language],
    "description": post.excerpt[language],
    "author": {
      "@type": "Person",
      "name": post.author[language]
    },
    "datePublished": post.publishDate,
    "dateModified": post.publishDate,
    "publisher": {
      "@type": "Organization",
      "name": "Acharya Abhishek Pandey",
      "logo": {
        "@type": "ImageObject",
        "url": "https://acharyaabhishekpandey.com/images/logo.png"
      }
    },
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": `https://acharyaabhishekpandey.com/blog/${post.slug}`
    },
    "keywords": post.keywords[language],
    "articleSection": post.category[language],
    "wordCount": post.content[language].replace(/<[^>]*>/g, '').split(' ').length,
    "timeRequired": post.readTime[language]
  };
};